import { useState, useEffect } from "react"
import { useParams, useNavigate } from 'react-router-dom'
import useApi from "../utilities/useApi";
import stringUtilities from "../utilities/stringUtilities";
import dateUtilities from "../utilities/dateUtilities";
import Loading from "./common/loading";
import { Container, Row, Col, Button, Form, Modal } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import OrganisationSelector from "./common/organisationSelector";
import enums from "../utilities/enums";
import arrayUtilities from "../utilities/arrayUtilities";

export default function LicenseAddEdit({ organisationId, organisationalUnits, isEdit }) {

    const { api } = useApi();
    const { sid } = useParams();
    const navigate = useNavigate();
    const licensesLandingUrl = `/${ organisationId }/admin-tools/licenses`;
    const [isLoading, setIsLoading] = useState(false)
    const [organisationalUnitId, setOrganisationalUnitId] = useState(null);
    const [users, setUsers] = useState(null);
    const [assignedUser, setAssignedUser] = useState(null);
    const [skus, setSkus] = useState(null);
    const [skuId, setSkuId] = useState(null);
    const [role, setRole] = useState(null);
    const [billTo, setBillTo] = useState(null);
    const [renewalDate, setRenewalDate] = useState(dateUtilities.addYears(new Date(), 1));
    const [adminEmail, setAdminEmail] = useState(null);
    const [canSave, setCanSave] = useState(false);
    const [errorModal, setErrorModal] = useState(null)
    const [readonlyFields, setReadonlyFields] = useState(null)
    const [quantity, setQuantity] = useState(0);

    const fetchLicense = () => {
        setIsLoading(true)
        api.getLicense(
            sid,
            data => {
                setOrganisationalUnitId(data.organisationalUnitId);
                setAssignedUser(data.userId);
                setSkuId(data.skuId)
                setRole(String(data.role))
                setBillTo(data.billTo)
                setRenewalDate(new Date(data.renewalDate))
                setAdminEmail(data.adminEmail)
                if (!stringUtilities.isNullOrEmpty(data.organisationalUnitId)) {
                    api.getUsers(data.organisationalUnitId, false, data => setUsers(data), error => console.log(error))
                }
                setReadonlyFields({
                    created: `${ dateUtilities.formatToDateString(data.created) } ${ dateUtilities.formatToTimeString(data.created) }`,
                    createdBy: data.createdByUserName
                })
                setIsLoading(false)
            },
            error => setErrorModal(error.errorMessage)
        )
    }
    useEffect(() => {
        if (isEdit) {
            fetchLicense()
        }
        fetchAllSkus()
    }, [])

    useEffect(() => {
        setCanSave(
            !stringUtilities.isNullOrEmpty(organisationalUnitId) &&
            !stringUtilities.isNullOrEmpty(skuId) &&
            renewalDate &&
            !stringUtilities.isNullOrEmpty(adminEmail) &&
            (isEdit || Number(quantity) > 0)
        )
    }, [organisationalUnitId, skuId, renewalDate, adminEmail, quantity])

    const fetchAllSkus = () => {
        api.fetchAllSkus(
            data => setSkus(data),
            error => console.log(error)
        )
    }

    const handleSubmit = () => {
        if (isEdit) {
            api.editLicense(
                sid, organisationalUnitId, !stringUtilities.isNullOrEmpty(assignedUser) ? assignedUser : null, skuId, Number(role), billTo, renewalDate, adminEmail,
                () => navigate(licensesLandingUrl),
                error => setErrorModal(error.errorMessage)
            )
        }
        else {
            api.addLicense(
                organisationalUnitId, !stringUtilities.isNullOrEmpty(assignedUser) ? assignedUser : null, skuId, Number(role), billTo, renewalDate, adminEmail, Number(quantity),
                () => navigate(licensesLandingUrl),
                error => setErrorModal(error.errorMessage)
            )
        }
    }

    return (
        <>
            {
                isLoading
                    ? <Loading />
                    : <Container className='pt-5 pb-lg-4 mt-5 mb-sm-2'>
                        <Row>
                            <Col className='mb-5'>
                                <div className='d-flex justify-content-between my-5'>
                                    <h1 className="h2 m-0">{ `${ isEdit ? "Edit" : "Add" } License` }</h1>
                                </div>
                                <div>
                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            Organisation
                                        </Form.Label>
                                        <div className="col-md-9 d-flex align-items-center">
                                            <OrganisationSelector hideIcon wrapperClassAddon="w-100" organisations={ organisationalUnits } value={ organisationalUnitId } onChange={ id => {
                                                setOrganisationalUnitId(id)
                                                if (!stringUtilities.isNullOrEmpty(id)) {
                                                    api.getUsers(id, false, data => setUsers(data), error => console.log(error))
                                                }
                                            } } />
                                        </div>
                                    </Form.Group>
                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            User
                                        </Form.Label>
                                        <div className="col-md-9 d-flex align-items-center">
                                            <Form.Select size='sm' value={ assignedUser } onChange={ e => setAssignedUser(e.target.value) }>
                                                <option value="">Select a user</option>
                                                { users?.map(item => <option key={ item.id } value={ item.id } id={ item.id }>{ item.name }</option>) }
                                            </Form.Select>
                                        </div>
                                    </Form.Group>

                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            SKU
                                        </Form.Label>
                                        <div className="col-md-9 d-flex align-items-center">
                                            <Form.Select size='sm' value={ skuId } onChange={ e => setSkuId(e.target.value) }>
                                                <option value="">Select a SKU</option>
                                                { 
                                                    !arrayUtilities.isNullOrEmpty(skus) &&  
                                                    skus.map(item => <option key={ item.id } value={ item.id } id={ item.id }>{ item.id }</option>)
                                                }
                                            </Form.Select>
                                        </div>
                                    </Form.Group>

                                    <Form.Group className='mb-3 row align-items-center'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            Role
                                        </Form.Label>
                                        <div className="col-md-9 d-flex align-items-center">
                                            <Form.Select size='sm' value={ role } onChange={ e => setRole(e.target.value) }>
                                                <option value="">Select a role</option>
                                                { Object.entries(enums.UserRole).map(([key, value]) => key !== "0" && <option key={ key } value={ key } id={ key }>{ value }</option>) }
                                            </Form.Select>
                                        </div>
                                    </Form.Group>

                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            Bill to
                                        </Form.Label>
                                        <div className="col-md-9 d-flex align-items-center">
                                            <Form.Control size='sm' value={ billTo } type="text" onChange={ e => setBillTo(e.target.value) } />
                                        </div>
                                    </Form.Group>
                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            Renewal Date
                                        </Form.Label>
                                        <div className="col-md-9 d-flex align-items-center">
                                            <Form.Control
                                                as={ DatePicker }
                                                selected={ renewalDate }
                                                value={ renewalDate }
                                                onChange={ date => setRenewalDate(date) }
                                                dateFormat="dd/MM/yyyy"
                                                className='rounded-start form-control-sm cursor-pointer'
                                            />
                                        </div>
                                    </Form.Group>

                                    <Form.Group className='mb-3 row'>
                                        <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                            Admin Email
                                        </Form.Label>
                                        <div className="col-md-9 d-flex align-items-center">
                                            <Form.Control size='sm' value={ adminEmail } type="email" onChange={ e => setAdminEmail(e.target.value) } />
                                        </div>
                                    </Form.Group>

                                    {
                                        isEdit && readonlyFields &&
                                        <>
                                            <Form.Group className='mb-3 row'>
                                                <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                                    Created
                                                </Form.Label>
                                                <div className="col-md-9 d-flex align-items-center">
                                                    <Form.Control size='sm' value={ readonlyFields.created } type="text" readOnly plaintext />
                                                </div>
                                            </Form.Group>

                                            <Form.Group className='mb-3 row'>
                                                <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                                    Created By
                                                </Form.Label>
                                                <div className="col-md-9 d-flex align-items-center">
                                                    <Form.Control size='sm' value={ readonlyFields.createdBy } type="text" readOnly plaintext />
                                                </div>
                                            </Form.Group>
                                        </>
                                    }
                                    {
                                        !isEdit && 
                                        <Form.Group className='mb-3 row'>
                                            <Form.Label className='form-label fs-sm col-form-label col-md-3'>
                                                Quantity
                                            </Form.Label>
                                            <div className="col-md-9 d-flex align-items-center">
                                                <Form.Control size='sm' value={ quantity } type="number" onChange={e => setQuantity(Number(e.target.value))} />
                                            </div>
                                        </Form.Group>
                                    }
                                </div>
                                <Form.Group className='mt-4 row justify-content-end'>
                                    <div className="col-md-9">
                                        <Button onClick={ () => navigate(licensesLandingUrl) } variant='outline-primary' size="sm">
                                            Cancel
                                        </Button>
                                        <Button disabled={ !canSave } onClick={ handleSubmit } size='sm' className='ms-2'>
                                            Submit
                                        </Button>
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                        {
                            errorModal &&
                            <Modal show onHide={ () => setErrorModal(null) } centered>
                                <Modal.Header>
                                    <Modal.Title>Error</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    { errorModal.errorMessage }
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button size="sm" variant='secondary' onClick={ () => setErrorModal(null) }>Close</Button>
                                </Modal.Footer>
                            </Modal>
                        }
                    </Container>
            }
        </>
    )
}